export default {
  'pet-recommendations:page-title': 'Individuell für deine Fellnase',
  'pet-recommendations:cdp:title:dog': 'Empfehlungen für deinen Hund',
};
